import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input, SearchableSelect } from "@/shared/ui";
import { BANKS } from "@/shared/consts/banks";
import type { ImportWorkerFormValues } from "../types";

export default function BankingSection() {
  const { t } = useTranslation("ImportWorkerPage");

  const {
    register,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext<ImportWorkerFormValues>();

  const bankName = watch("bank_name");

  const selectedBank = BANKS.find((b) => b.name === bankName) ?? null;

  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-display-2xs content-base-primary">{t("sections.banking")}</h2>

      <SearchableSelect
        label={t("banking.bankName")}
        placeholder={t("banking.bankNamePlaceholder")}
        options={BANKS}
        searchKeys={["name"]}
        displayKey="name"
        value={selectedBank}
        hasRequiredLabel
        onChange={(bank) => {
          setValue("bank_name", bank?.name ?? "", { shouldValidate: true });
          setValue("bik_number", bank?.bik ?? "", { shouldValidate: true });
        }}
        error={errors.bank_name?.message ? t(errors.bank_name.message) : undefined}
      />

      <Input
        label={t("banking.ibanAccount")}
        placeholder={t("banking.ibanPlaceholder")}
        maxLength={20}
        hasRequiredLabel
        {...register("iban_account")}
        error={errors.iban_account?.message ? t(errors.iban_account.message) : undefined}
      />

    </div>
  );
}
